import { Alert, Button,  List, ListItem, Stack, Typography } from '@mui/material';
import GeneralBlockComponent from "./components/GeneralBlockComponent";
import AIANBlockComponent from "./components/AIANBlockComponent";
import { useUserInfoQuery } from "../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../api/ducApiSlice";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { colours } from '../../StyleConstants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const DUCDashboard = () => {
    const { data: userData } = useUserInfoQuery({});
    const { refetch } = useGetDUCInfoQuery({ email: userData?.email });



    const handleRefresh = () => {
        refetch()
    }


    return (

        <Stack
            flexDirection= "column"
            gap={3}
            height="100%"
            paddingX={3}
        >

            <Stack
                gap={3}
            >
                <Typography>
                    This Data Use Certification (DUC) Agreement outlines the terms of use for access to data from NIH
                    Brain Development Cohorts,
                    including the Adolescent Brain Cognitive Development<sup>&#8480;</sup> (ABCD) Study and the HEALthy
                    Brain and Child Development (HBCD) Study. The ABCD Study<sup>&reg;</sup> is a longitudinal study of
                    nearly 12,000
                    youth beginning at ages 9-10 and continuing into early adulthood to assess factors that influence
                    individual brain development trajectories and functional outcomes. The HBCD Study is a longitudinal
                    study of early brain and child development that will follow participating families from pregnancy
                    through early childhood. Both studies have adopted an open science model, making data available to
                    researchers around the world, including fast-track raw neuroimaging data that are released on an
                    ongoing basis, as well as curated data released annually. Authorization requires users to submit a signed DUC that includes
                    signature by the user’s institution business official.
                </Typography>
                <Stack alignItems={"flex-start"} gap={4}>
                    <Alert
                        icon={<InfoOutlinedIcon
                            fontSize="inherit"
                            sx={{ color: colours.notifications.info }} />}
                        sx={{ backgroundColor: colours.notifications.info10 }
                        }
                    >
                        <Typography variant="h3" fontSize="20px" fontWeight="600">Application process:</Typography>
                        <List dense>
                            <ListItem >
                                <Typography>
                                    1. You will need to fill out the request form (accessed below), sign the document and submit for approval.
                                </Typography>

                            </ListItem>
                            <ListItem >
                                <Typography>
                                    2. Ensure you know who your institution’s signing official is, as their signature is required for data access approval.
                                </Typography>
                            </ListItem>
                            <ListItem >
                                <Typography>
                                    3. You must confirm whether your institution complies with federal security standards—specifically NIST SP 800-171 or equivalent ISO/IEC 27001/27002 standards.
                                    If you’re unsure, please consult your compliance office. <a
                                        href="https://cdn.prod.website-files.com/672cec1c3c6a5c9ee60d1184/67e4446c397e5fbf09e3bba1_f301bb8ba8f8a4adff71d7579e18994f_NIST%20security%20compliance%20update.pdf"
                                        target="_blank" rel="noreferrer"
                                    >
                                        View the NIST Security Compliance Requirements for more information.
                                    </a>
                                </Typography>
                            </ListItem>
                            <ListItem >
                                <Typography>
                                    4. Once submitted, your request will be reviewed by your signing official and signed once approved.
                                </Typography>
                            </ListItem>
                            <ListItem >
                                <Typography>
                                    5. After approval and signing by the committee, your certification will be approved.
                                </Typography>
                            </ListItem>
                        </List>
                        <Typography>
                            <strong>NOTE: If your request is declined at any step, you may need to fill out, sign, and
                                submit a new form. In this case, users should email
                                the NBDC Data Access Committee at nbdc@mail.nih.gov to inquire. </strong>
                        </Typography>

                    </Alert>
                </Stack>
            </Stack>
            <Stack>
                <Stack>
                    <Button
                        onClick={handleRefresh}
                        startIcon={<RotateLeftIcon />}
                        sx={{
                            width: 'max-content', // Adjust width to content size
                        }}>
                        Refresh
                    </Button>
                </Stack>
                <Stack
                    flexDirection= "column"
                    gap={3}>
                    <GeneralBlockComponent/>
                    <AIANBlockComponent/>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default DUCDashboard;